import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { Img } from "./styles";

const SelectLanguageComponent = () => {

  const { i18n } = useTranslation();
  const handleClick = (leng) => i18n.changeLanguage(leng);

  const BotLanguage = (props) => {
    return(
    <Button size= {props.size} ghost shape={props.shape} onClick={() => handleClick(props.clickT)} type={i18n.language === props.typeText ? "primary" : "default"}>
      <Img alt={props.imgAlt} src={props.imgSrc} />
    </Button>)
  }
  return (
    <span>
      <BotLanguage size="small" shape="circle" clickT="es-ES" typeText="es-ES" imgAlt="es-ES" imgSrc="/bikiforge/flags/es-ES.png"/>
      <BotLanguage size="small" shape="circle" clickT="eus" typeText="eus" imgAlt="eus" imgSrc="/bikiforge/flags/eus.png"/>
      <BotLanguage size="small" shape="circle" clickT="en-US" typeText="en-US" imgAlt="en-UK" imgSrc="/bikiforge/flags/en-UK.png"/>
    </span>
  );
};
export default SelectLanguageComponent;